/* Copyright (c) 2019 - 2021. Verimatrix. All Rights Reserved.
   All information in this file is Verimatrix Confidential and Proprietary. */

export default {
  Auth: {
    // REQUIRED - Amazon Cognito Identity Pool ID
    identityPoolId: process.env.REACT_APP_AWS_AUTH_IDENTITY_POOL_ID,
    // REQUIRED - Amazon Cognito Region
    region: process.env.REACT_APP_AWS_AUTH_REGION,
    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: process.env.REACT_APP_AWS_AUTH_USER_POOL_ID,
    // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
    userPoolWebClientId: process.env.REACT_APP_AWS_AUTH_USER_POOL_WEB_CLIENT_ID,
    // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
    mandatorySignIn: process.env.REACT_APP_AWS_AUTH_MANDATORY_SIGN_IN,
    // OPTIONAL - Manually set the authentication flow type. Default is 'USER_SRP_AUTH'
    //    authenticationFlowType: 'USER_PASSWORD_AUTH',

    // OPTIONAL - Configuration for cookie storage
    // Note: if the secure flag is set to true, then the cookie transmission requires a secure protocol
    cookieStorage: {
      // REQUIRED - Cookie domain (only required if cookieStorage is provided)
      // domain: 'localhost',
      domain: process.env.REACT_APP_AWS_COOKIE_DOMAIN,
      // OPTIONAL - Cookie path
      path: "/",
      // OPTIONAL - Cookie expiration in days
      expires: 1,
      // OPTIONAL - Cookie secure flag
      // Either true or false, indicating if the cookie transmission requires a secure protocol (https).
      secure: process.env.REACT_APP_AWS_COOKIE_SECURE === "true",
    },
  },
  API: {
    graphql_endpoint: process.env.REACT_APP_AWS_GRAPHQL_ENDPOINT,
    graphql_endpoint_iam_region: process.env.REACT_APP_AWS_AUTH_REGION,
    correlation_endpoint: process.env.REACT_APP_AWS_CORRELATION_ENDPOINT,
    endpoints: [
      {
        name: "ApsBackend",
        endpoint: process.env.REACT_APP_AWS_APS_API_ENDPOINT,
      },
    ],
  },
};
